module.exports = __webpack_public_path__ + "static/media/email-color.13a91fd5.svg";